import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';

export class GalaxyDateAdapter extends DateFnsAdapter {}

export const MY_DATE_FORMATS = MAT_DATE_FNS_FORMATS;

MY_DATE_FORMATS.display.dateInput = 'PPP';
